<template>
  <div id="live-calendar">
    <div v-if="notMonitored" class="not-monitored">
      <div class="title">该直播暂未被监控</div>
      <div class="description">添加直播监控后即可获得该达人直播场次，以及直播人气、礼物打赏和商品销售数据</div>
      <div class="btn" @click="$emit('monitor')">添加监控</div>
    </div>
    <!--横向日期目录-->
    <div v-else ref="scrollBar" class="scroll-bar">
      <a
        v-for="item of tableData"
        :key="item.date"
        class="btn"
        :class="{ 'active-btn': activeBtn === item.date }"
        @click="selectDate(item.date)"
      >{{ formatDate(String(item.date), 'MM-DD') }}</a>
    </div>
    <!--单日block-->
    <div :key="item.date" v-for="(item ) in tableData">
      <!--因为头顶有日期悬浮框，锚点直接定位在正文上会被悬浮框挡住-->
      <div  :id="'detail' + item.date"></div>
      <div  class="detail">
        <div>
          <img class="icon" src="https://s6.bihukankan.com/img/0715calendar.png" alt="icon" />
          <span class="date">{{ formatDate(String(item.date)) }}</span>
        </div>
        <span v-if="showSales(item.liveStreamLog) !== '未卖货'" class="share-btn" @click="gotoShare(item)">直播卡片</span>
        <div class="time-statistics">
          直播
          <span class="din">{{ item.liveStreamLog.length }}场</span>
          ，累计时长
          <span class="din">{{ formatDuration(item.liveStreamLog) }}</span>
        </div>
        <div class="money-statistics" @click="openPopup('Goods', item)">
          <div style="display: flex;flex-flow: row nowrap;align-items: center">
            <div class="text">销售额</div>
            <div class="din" :class="{ orange: showSales(item.liveStreamLog) !== '未卖货' }" style="font-size: .36rem">
              <span v-if="showSales(item.liveStreamLog) !== '未卖货' && showSales(item.liveStreamLog) !== '****'" style="font-size: 12px;">¥</span>
              {{ showSales(item.liveStreamLog) }}
              <span class="vip-icon" style="align-self: center" v-if="showSales(item.liveStreamLog) === '****'">VIP</span>
            </div>
          </div>
          <div class="btn">
            查看商品列表
            <van-icon name="arrow" />
          </div>
        </div>
        <!--下播追踪-->
        <DowncastTracking :date="item.date" v-if="showSales(item.liveStreamLog) !== '未卖货'" style="margin-top: 24px" :data="item.liveStreamLog"/>
        <!--          <div class="money-statistics" @click="openPopup('PkBlock', item)">-->
        <!--            <div class="text">当日PK人数</div>-->
        <!--            <div class="num din">-->
        <!--              {{item.pkAnchorCount || '无'}}-->
        <!--            </div>-->
        <!--            <div class="btn">-->
        <!--              PK详情-->
        <!--              <van-icon name="arrow" style="vertical-align: top" />-->
        <!--            </div>-->
        <!--          </div>-->
        <!--单场直播block-->
        <div v-for="live of item.liveStreamLog" :key="live.id" class="live" @click="goToLive(live,showSales(item.liveStreamLog),item)">
          <!--毛玻璃-->
          <img class="frosted-glass" :src="$changeCDN(live.poster) || placeholder" :onerror="onerror" />
          <div class="content">
            <span class="text din">
              <div class="line">{{ formatDate(live.startTime * 1000, 'HH:mm') }} 开播</div>
              <div class="line">{{ formatDuration([live]) }}</div>
              <div class="line title">{{ live.title }}</div>
              <div class="line">
                <template v-if="showSales([live]) !== '未卖货'">¥</template>
                {{ showSales([live]) }}
              </div>
              <div>
                直播详情
                <van-icon name="arrow" style="vertical-align: top" />
              </div>
            </span>
            <img :src="$changeCDN(live.poster) || placeholder" class="cover" alt="cover" :onerror="onerror" />
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '80%' }">
      <keep-alive>
        <component v-if="showPopup" :is="popupType" :liveInfo="liveInfo" :liveStreamLog="liveStreamLog" @close="showPopup = false" />
      </keep-alive>
    </van-popup>
  </div>
</template>

<script>
import Goods from './Goods';
import Income from './Income';
import Expend from './Expend';
import PkBlock from './PkBlock'
import DowncastTracking from "./downcastTracking/index.vue";
export default {
  components: { Goods, Income, Expend, PkBlock,DowncastTracking },
  data() {
    return {
      liveInfo:{},
      activeBtn: null,
      date: new moment(),
      tableData: [],
      showPopup: false,
      popupType: '',
      liveStreamLog: [],
      placeholder: 'https://s6.bihukankan.com/common/default.png',
      notMonitored: false,
      onerror: `this.src='https://s6.bihukankan.com/common/default.png'`
    };
  },
  async mounted() {
    this.addShadow();
   
    await this.getData();
    // // 30请求到的天数会重复😂
    // this.date.subtract(31, 'd');
    // await this.getData();
    // this.date.subtract(31, 'd');
    // await this.getData();
  },
  computed:{
    isProVip(){
      return this.$store.state.userLevel && this.$store.state.userLevel <= 95
    }
  },
  methods: {
    addShadow() {
      if(!this.notMonitored) return;
      window.onscroll = e => {
        if (!this.$refs.scrollBar.getBoundingClientRect().top) {
          this.$refs.scrollBar.style = 'box-shadow: 0 10px 10px rgba(202, 211, 223, 0.5)';
        } else {
          this.$refs.scrollBar.style = '';
        }
      }
      this.$once("hook:beforeDestroy", () => {
        window.onscroll=null
      });
    },
    selectDate(date) {
      this.activeBtn = date;
      // 不记录锚点跳转记录，防止返回上一页返回的是上个锚点
      location.replace('#detail' + date);
    },
    formatDate(date, template = 'YYYY-MM-DD') {
      return moment(date).format(template);
    },
    formatDuration(arr) {
      let unix = 0;
      for (const live of arr) {
        unix += live.stopTime - live.startTime;
      }
      const hours = parseInt(unix / 3600);
      const minutes = parseInt(unix / 60) % 60;
      return hours ? `${hours}小时${minutes}分钟` : minutes + '分钟';
    },
    gotoShare({ date }) {
      if (!this.$store.state.userLevel || this.$store.state.userLevel > 100) {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true, textChange: 'share' });
        return;
      }
      this.$router.push(`/live/${this.$route.params.id}/${date}/card`)
    },
    showSales(arr) {
      let money = 0;
      let commodityCount = 0
      for (const live of arr) {
        money += Number(live.sales);
        commodityCount += isNaN(live.commodityCount)?0:live.commodityCount
      }
      if (isNaN(money)) {
        return '****';
      }
      this.flag = commodityCount === 0 ?  '未卖货' :this.$retainWan(money.toFixed(2))
      return commodityCount === 0 ?  '未卖货' :this.$retainWan(money.toFixed(2))
    },
    showIncome(arr) {
      let money = 0;
      for (const live of arr) {
        money += Number(live.gifts);
      }
      return money ? this.$kuaibiCoin(money.toFixed(2)) : '0';
    },
    openPopup(type, data) {
      // 开通年费会员
      if ((!this.$store.state.userLevel || this.$store.state.userLevel > 95) && type === 'Expend') {
        this.$store.commit('WRITEOVERLAYSHOW', {
          status: true,
          textChange: 'giftOut'
        });
        return;
      }
      if ((!this.$store.state.userLevel || this.$store.state.userLevel > 95) && type === 'PkBlock') {
        this.$store.commit('WRITEOVERLAYSHOW', {
          status: true,
          textChange: 'PkBlock'
        });
        return;
      }
      if (!this.$store.state.userLevel || this.$store.state.userLevel > 100) {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true, textChange: 'liveCalendar' });
        return;
      }
      // 挂榜会员lv也是100，难搞
      if (type === 'Goods' && this.showSales(data.liveStreamLog) === '¥ ****') {
        this.$store.commit('WRITEOVERLAYSHOW', { status: true, textChange: 'liveCalendar' });
        return;
      }
      if (type === 'Goods' && this.showSales(data.liveStreamLog) === '未卖货') {
        this.$toast('该主播当日没有卖货');
        return;
      }
      if (type === 'Income' && this.showIncome(data.liveStreamLog) === '¥ 0') {
        this.$toast('该主播当日没有收到礼物');
        return;
      }
      if (type === 'Expend' && !data.sentGifts) {
        this.$toast('该主播当日没有对外打赏');
        return;
      }
      if (type === 'PkBlock' && !data.pkAnchorCount) {
        this.$toast('该主播当日没有PK记录');
        return;
      }
      this.popupType = type;
      this.liveStreamLog = data.liveStreamLog;
      this.liveInfo = data
      this.showPopup = true;
    },
    goToLive(live,flag,item) {
      if(flag === '未卖货') {
        this.openPopup('Goods',item)
      } else {
        this.$router.push({ path: `/live/${this.$route.params.id}/${live.id}` });
      }
    },
    async getData() {
      if (this.notMonitored) {
        return;
      }
      const nearDay=90//近90
      const nowTime=moment().endOf('day').unix()
      const oldTime=moment().subtract(nearDay, "day").endOf('day').unix()
        const res = await this.$get({
          road: 'liveCalendar',
          data: { road: 'gifshow', anchorId: this.$route.params.id },  //
          params: { date: JSON.stringify({ $between: [oldTime, nowTime] }) },
          version: 'v2'
        }).catch(err=>{
          if (err.response.code === 20001013) {
          this.notMonitored = true;
        } else {
          this.$toast.fail(err.response.message);
        }
        return[]
        })
        for (let i = res.length - 1; i >= 0; i--) {
          if (res[i].liveStreamLog.length) {
            this.tableData.push(res[i]);
          }
        }
    
    },
  }
};
</script>

<style lang="less">
* {
  scroll-behavior: smooth;
}

#live-calendar {
  ::-webkit-scrollbar {
    display: none;
  }
  .din {
    font-family: 'number-bold';
    font-weight: 500;
  }
  .not-monitored {
    text-align: center;
    padding: 1.5rem 0.75rem 1rem;

    .title {
      color: #4a4a4a;
      margin-bottom: 0.3rem;
    }

    .description {
      color: #a1aebf;
      line-height: 0.48rem;
      margin-bottom: 0.56rem;
    }

    .btn {
      width: 3rem;
      height: 1rem;
      border-radius: 0.08rem;
      margin: 0 auto;
      background: linear-gradient(180deg, #ffc900 0%, #ff9900 100%);
      font-size: 0.36rem;
      line-height: 1rem;
      color: white;
    }
  }

  .orange {
    color: #ff5500;
    font-size: 0.36rem;
    font-weight: bold;
  }

  .scroll-bar {
    position: sticky;
    top: 0;
    background: white;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    height: 1.2rem;
    padding: 0.3rem;
    z-index: 2;
    width: 100vw;

    .btn {
      display: inline-block;
      width: 1.5rem;
      height: 0.6rem;
      background: #f0f2f5;
      border-radius: 0.08rem;
      line-height: 0.6rem;
      margin: 0 0.1rem;
      text-align: center;
      font-family: number-bold;
      font-weight: bold;
      color: #4a4a4a;
    }

    .active-btn {
      color: #2a89f4;
    }
  }

  :target {
    margin-top: -1.5rem;
    padding-top: 1.2rem;
  }

  .detail {
    background: white;
    margin: 0.3rem;
    padding: 0.2rem;
    box-shadow: 0 0.02rem 0.2rem 0 rgba(202, 211, 223, 0.5);
    border-radius: 0.16rem;
    position: relative;

    .share-btn {
      position: absolute;
      top: 0.2rem;
      right: 0.3rem;
      padding: 0.15rem 0.2rem;
      border-radius: 0.08rem;
      border: 0.01rem solid #ff9900;
      font-size: 0.28rem;
      font-weight: 400;
      color: #ff9900;
    }

    .icon {
      width: 0.36rem;
      height: 0.36rem;
      vertical-align: top;
      margin-right: 0.1rem;
    }

    .date {
      font-size: 0.36rem;
      color: #4a4a4a;
      font-weight: bold;
      font-family: number-bold;
    }

    .time-statistics {
      color: #a1aebf;
      font-size: 0.24rem;
      margin-top: 0.1rem;
      padding-bottom: 0.15rem;
      border-bottom: 0.01rem solid #cad3df;
    }

    .money-statistics {
      margin-top: 22px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      font-size: 0.2rem;
      text-align: center;
      .text {
        color: #252E39;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        margin-right: 8px;
      }
      .num {
        color: #FF5000;
        font-family: Roboto;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
      }

      .btn {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        color: #8E9AAE;
        text-align: right;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }

    .live {
      position: relative;
      width: 6.5rem;
      height: 2.6rem;
      overflow: hidden;
      margin-top: 0.35rem;

      .frosted-glass {
        width: 6.5rem;
        height: 2.6rem;
        filter: blur(0.1rem) brightness(70%);
        transform: scale(1.1);
      }

      .content {
        color: white;
        position: absolute;
        top: 0;
        z-index: 1;

        .text {
          display: inline-block;
          padding: 0.3rem 0.2rem;
          font-size: 0.2rem;
          width: 2.45rem;
          height: 2.6rem;

          .title {
            overflow-x: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .line {
            margin-bottom: 0.2rem;
          }
        }

        .cover {
          width: 1.6rem;
          height: 2.6rem;
          vertical-align: top;
          object-fit: cover;
        }
      }
    }
  }

  .van-popup {
    background: #f2f1f8;
  }
}
</style>
